import React, { useEffect, useState } from 'react';
import { Box, Container } from '@material-ui/core';
import { useParams } from 'react-router';
import { useSnackbar } from 'notistack';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import EditPaymentLinkForm from './EditPaymentLinkForm';
import SplashScreen from '../../../components/Loading/SplashScreen';
import handleApiResponse from '../../../utils/handleApiResponse';
import useStyles from './styles';
import { getPaymentLinkById } from '../../../requests/api/paymentLinks';

function PaymentLinkEditView() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const [link, setLink] = useState(null);

  useEffect(() => {
    const getLink = async () => {
      try {
        const response = await getPaymentLinkById(id);
        setLink(response.paymentLink);
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    getLink();
  }, [id]);

  if (!link) return <SplashScreen />;

  return (
    <Page className={classes.root} title="Editar Link de Pago">
      <Container maxWidth={false}>
        <Header />
        <Box mt={3}>
          <EditPaymentLinkForm link={link} />
        </Box>
      </Container>
    </Page>
  );
}

export default PaymentLinkEditView;
